import React from 'react';
import {
  Box, Button, Dialog, Grid, styled, Typography,
} from '@material-ui/core';
import CustomInput from '../../form/CustomInput';
import { Rules } from '../../../helpers/RHFRules';

const getGeneralStyles = (theme, height, alignItems = 'center') => ({
  '& .MuiOutlinedInput-root': {
    position: 'relative',
    borderRadius: '10px',
    boxShadow: '1px 5px 5px #d7d7d7',
    '& svg': {
      color: theme.backOffice.contracts.tableProducts.colorIcon,
    },
    height,
    alignItems,
  },
  paddingBottom: '24px',
});

const MyDialog = styled(Dialog)({
  '& .MuiDialog-paper': {
    borderRadius: '10px',
    maxWidth: '508px',
    height: '526px',
    padding: '40px',
  },

});

const MyTypography = styled(Typography)(({ theme }) => ({
  fontFamily: 'Mulish, sans-serif',
  color: theme.alertPopup.titleAlert.color,
  fontWeight: 700,
  fontSize: 20,
  paddingBottom: 24,
  textAlign: 'center',
}));

const MyCustomInput = styled(CustomInput)(({ theme, height = 36 }) => ({
  ...getGeneralStyles(theme, height),
}));

const MyCustomInput2 = styled(CustomInput)(({ theme, height = 36 }) => ({
  ...getGeneralStyles(theme, height, 'flex-start'),
  paddingBottom: '24px',
  '& .MuiOutlinedInput-inputMultiline': {
    paddingTop: '5px',
    paddingBottom: '5px',
  },
}));

const MyButton = styled(Button)(() => ({
  fontSize: 14,
  borderRadius: 10,
}));

const MyBox = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
  paddingBottom: '24px',
}));

const ObservationsConfirm = (props) => {
  const {
    isOpen,
    firstImage,
    textTitle,
    objInputs,
    objControl,
    objButtons,
  } = props;

  return (
    <MyDialog open={isOpen} fullWidth={false}>
      <MyBox mt={2}>
        {firstImage}
      </MyBox>
      <Grid container>
        <Grid item xs={12}>
          <MyTypography>{textTitle}</MyTypography>
        </Grid>
        <Grid item xs={12}>
          <MyCustomInput
            label={objInputs?.label1}
            name={objInputs?.name1}
            control={objControl?.control}
            error={objControl?.errors}
            required
            styleFromHelperText={{ style: { marginRight: 10 } }}
            rule={Rules.letrasNumeros}
            inputProps={{
              maxLength: 20,
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <MyCustomInput2
            label={objInputs?.label2}
            name={objInputs?.name2}
            control={objControl?.control}
            error={objControl?.errors}
            required
            multiline
            rows={4}
            InputLabelProps={{ shrink: true }}
            styleFromHelperText={{ style: { marginRight: 10 } }}
            rule={Rules.required}
            inputProps={{
              maxLength: 200,
            }}
            height={144}
          />
        </Grid>
        <Grid container justifyContent="center" spacing={3}>
          <Grid item>
            <MyButton
              variant="contained"
              onClick={objButtons?.handleCancel}
              style={objButtons?.styleButtonCancel}
            >
              {objButtons?.textCancel}
            </MyButton>
          </Grid>
          <Grid item>
            <MyButton
              variant="contained"
              onClick={objButtons?.handleAccept}
              style={objButtons?.styleButtonAccept}
            >
              {objButtons?.textAccept}
            </MyButton>
          </Grid>
        </Grid>
      </Grid>
    </MyDialog>
  );
};

export default ObservationsConfirm;
